import { render, staticRenderFns } from "./PointPresenter.vue?vue&type=template&id=3344fa4f&scoped=true&"
import script from "./PointPresenter.vue?vue&type=script&lang=ts&"
export * from "./PointPresenter.vue?vue&type=script&lang=ts&"
import style0 from "./PointPresenter.vue?vue&type=style&index=0&id=3344fa4f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3344fa4f",
  null
  
)

export default component.exports